// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21UxI","label":"styles_label__SIc-9"};